module.exports = __webpack_public_path__ + "img/sdk-0-1.d37443a.svg";